import { ReactNode } from 'react'
import Header from './Header'
import Footer from './Footer'

interface LayoutProps {
  children: ReactNode
}

function Layout({ children }: LayoutProps) {
  return (
    <div className="min-vh-100 d-flex flex-column">
      <div className="header-background">
        <Header />
      </div>
      <main className="flex-fill main-background">
        {children}
      </main>
      <div className="footer-background">
        <Footer />
      </div>
    </div>
  )
}

export default Layout